/**
 * FlooredTitle: a one-line task title in a flex row that holds a client's
 * name and a date (LP-43). The title truncates first: the row squeezes it
 * down to its own width or 8rem, whichever is less, before the name
 * beside it gives way; the date never does. The floor is CSS alone
 * (.floored-title, src/index.css). The element is a flex item that grows
 * into the row's spare room; its font classes sit on it so the floor
 * measures the title in the title's own type.
 */

import type { ReactNode } from 'react';

export function FlooredTitle({ text, className }: { text: string; className: string }): ReactNode {
  return (
    <span data-title={text} data-testid="floored-title" className={`floored-title block flex-1 ${className}`}>
      <span className="block min-w-full max-w-0 truncate">{text}</span>
    </span>
  );
}
